<template>
  <v-container grid-list-md>
    <!-- <p>{{ AccountNumber }}</p> -->
    <v-card flat>
      <v-form ref="ExchangeForme" v-model="valid">
        <v-row dense no-gutters class="justify-center">
          <v-col cols="12" md="6" lg="6" xl="6">
            <v-radio-group
              readonly
              :rules="[v => !!v || 'Exchang Type is required']"
              v-model="Exchange.sellOrBuy"
              :column="false"
            >
              <v-radio class="mr-3" label="Sell" value="Sell"></v-radio>
              <v-radio label="Buy" class="ml-3" value="Buy"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="8">
            <BaseDate
              v-model="Exchange.date"
              outlined
              :rules="v => !!v || 'Date is required'"
            />
          </v-col>
          <v-col cols="8">
            <v-select
              v-model.trim="Exchange.sellorBuyType"
              :items="GetCashTypes"
              :rules="[v => !!v || 'Cash Type is required']"
              label="Cash Type"
              required
            ></v-select>
          </v-col>
          <!-- currency Amount and its formating Number -->
          <v-col cols="8">
            <v-text-field
              v-model.number.trim="Exchange.sellorBuyAmount"
              :rules="[v => !!v || 'Amount is required']"
              name="ExchangeAmount"
              label="Amount"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <p
              v-if="Exchange.sellorBuyAmount"
              class="font-weight-black text-center black--text"
            >
              {{ Exchange.sellorBuyType | MoneySigns }}
              {{ Exchange.sellorBuyAmount.toLocaleString() }}
            </p>
          </v-col>
          <!-- currency Rate and its Calculation Number -->
          <v-col cols="8">
            <v-select
              v-model.trim="ExchangType"
              :items="
                Exchange.sellorBuyType == UsersToken.CashBase
                  ? CurrencyTyps
                  : GetCashTypes
              "
              :rules="[v => !!v || 'Exchange Type is required']"
              :disabled="ExchangType == UsersToken.CashBase ? true : false"
              label="Exchange Type"
              required
            ></v-select>
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model.number.trim="Exchange.Rate"
              :rules="[v => !!v || 'Rate is required']"
              name="ExchangeAmountRate"
              label="Rate"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <p
              class="font-weight-black text-center black--text"
              v-if="localCurrence && localCurrence > 0"
            >
              <!-- {{ localCurrence.toLocaleString() }} -->
              {{ (Math.round(localCurrence * 100) / 100).toLocaleString() }}

              {{ ExchangType | MoneySigns }}
            </p>
          </v-col>
        </v-row>
      </v-form>

      <v-card-actions>
        <v-btn
          block
          :loading="clicked"
          :color="colorChange"
          @click="OnBankExchange"
          >{{ Exchange.sellOrBuy }} - Money</v-btn
        >
      </v-card-actions>
      <p class="text-center mb-3 red--text d-block">{{ ErrorMsg }}</p>
      <!-- <p class="text-center mb-3 red--text d-block">{{ AccountNumber }}</p> -->
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    AccountNumber: [String],
    showBalance: { type: Function },
    closed: { type: Boolean },
    isLoading: { type: Function },
  },
  data() {
    return {
      //   sellOrBuy: "",
      BaseURL: "/qarash/qaas",
      valid: true,
      ErrorMsg: "",
      clicked: false,
      ExchangType: "",
      Exchange: {
        sellorBuyAmount: "",
        date: "",
        Rate: "",
        sellorBuyType: "",
        sellOrBuy: "",
        Amount: "",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes", "UsersToken"]),

    CurrencyTyps() {
      if (this.GetCashTypes.length > 0)
        return this.GetCashTypes.filter(value => {
          return value.value != this.UsersToken.CashBase;
        });
      else return [];
    },
    colorChange() {
      if (this.Exchange.sellOrBuy === "Sell") return "green white--text";
      else if (this.Exchange.sellOrBuy == "Buy") return "yellow black--text";
      else return "grey white--text";
    },
    watchSellOrBuyType() {
      return this.Exchange.sellorBuyType;
    },
    localCurrence() {
      if (
        this.Exchange.Rate &&
        this.Exchange.sellorBuyAmount &&
        !isNaN(this.Exchange.Rate) &&
        !isNaN(this.Exchange.sellorBuyAmount)
      )
        if (this.Exchange.sellorBuyType == this.UsersToken.CashBase)
          return (
            Number(this.Exchange.sellorBuyAmount) / Number(this.Exchange.Rate)
          );
        else return this.Exchange.Rate * this.Exchange.sellorBuyAmount;
      else return 0;
    },
  },
  watch: {
    watchSellOrBuyType(v) {
      if (v == this.UsersToken.CashBase) {
        this.Exchange.sellOrBuy = "Sell";
        this.ExchangType = "USD";
      } else if (this.closed) {
        this.Exchange.sellOrBuy = "Buy";
        this.ExchangType = this.UsersToken.CashBase;
      }
    },
    localCurrence(val) {
      this.Exchange.Amount = Math.round(val * 100) / 100;
    },
    closed(val) {
      if (!val) {
        this.$refs.ExchangeForme.reset();
        this.isLoading(false);
      }
    },
  },
  methods: {
    OnBankExchange() {
      this.ErrorMsg = "";

      if (this.$refs.ExchangeForme.validate()) {
        this.isLoading(true);
        this.clicked = true;
        // this.Exchange.date = this.Current().date;
        this.Exchange.time = this.Current().time;
        this.Exchange.homeType = this.UsersToken.CashBase;
        let data = { ...this.Exchange, ClientAccount: this.AccountNumber };
        if (this.Exchange.sellOrBuy == "Sell") {
          data.Amount = this.Exchange.sellorBuyAmount;
          data.sellorBuyAmount = this.Exchange.Amount;
          data.sellorBuyType = this.ExchangType;
        }
        // console.log(data);
        this.$store
          .dispatch("INSERT_ONLY", {
            url: `/qarash/qaas/${this.Exchange.sellOrBuy}`,
            data,
          })
          .then(result => {
            this.isLoading(false, "Finished");
            this.clicked = false;
            this.showBalance(result.data);
            this.$refs.ExchangeForme.reset();
            // console.log(result);
          })
          .catch(error => {
            // console.log(error);
            this.clicked = false;
            this.isLoading(false);
            if (error.response.status === 400)
              this.ErrorMsg = error.response.data;
            else if (error.response.status === 451)
              this.ErrorMsg = error.response.data;
            else this.ErrorMsg = error && error.response && error.response.data;
          });
      }
    },
  },
  mounted() {
    this.isLoading(false);
  },
};
</script>
